import { ObjectModel } from 'objectmodel';

const Task = new ObjectModel({
  data: {
    type: ['name', 'url', 'push-app'],
    url: [String],
    name: [String]
  },
  name: String,
  origin: String,
  getFilterResults: Boolean
});

export { Task };



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/Task.js
 **/